import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import {
    updateParameters,
    trackMapClick,
    trackMobileMapToggleClick,
    trackMoreFiltersClick,
    trackSortingDropdownClick,
    trackSearchRequestId,
} from '../../actions';
import { getSearchParameters, getNumberOfAppliedRefinements } from '../../state/parameters';
import withLocation from '../../../config/location/withLocation';
import { showFacetedSearchBar } from '../../../config/ab/selector';

import SearchResultsWithMap from './SearchResultsWithMap';

const mapStateToProps = (state, ownProps) => {
    const {
        __showMobileMap,
        __showRefinePanel,
        address: searchAddress,
        carrierId,
        procedureId: searchProcedureId,
        specialtyId: searchSpecialtyId,
    } = getSearchParameters(state);

    const shouldRenderFacetedSearchBar = ownProps.shouldRenderFacetedSearchBar === false
        ? false
        : showFacetedSearchBar(state);

    return {
        __showMobileMap,
        __showRefinePanel,
        carrierId,
        refinementCount: getNumberOfAppliedRefinements(state),
        searchAddress,
        searchProcedureId,
        searchSpecialtyId,
        shouldRenderFacetedSearchBar,
    };
};
const mapDispatchToProps = {
    updateParameters,
    trackMapClick,
    trackMobileMapToggleClick,
    trackMoreFiltersClick,
    trackSortingDropdownClick,
    trackSearchRequestId,
};

export default flowRight(
    withLocation,
    withTheme,
    connect(mapStateToProps, mapDispatchToProps),
)(SearchResultsWithMap);
